const systemConfig = {
  state: {
    _storage: 'zyx_', // 本地存储前缀
    // P0：类型 (1|图文  2|视频  3|URL  4|图片集 8|竖屏视频)
    p0Img: 1,
    p0Url: 3,
    p0Video: 2,
    p0VideoShu: 8,
    p0Imgs: 4,
    upLoadUrl: 'https://rmtzx.zyxrmtzx.com/api/upload/upload_image', // 上传图片地址
    reportShow: true //举报入口是否显示
  },
  mutations: {
    REPORT_STATE: (state, val) => {
      state.reportShow = val;
    }
  },
  actions: {
    // 关闭举报入口
    reportClose({
      commit
    }, value) {
      commit('REPORT_STATE', value);
    }
  }
}

export default systemConfig



// WEBPACK FOOTER //
// ./src/store/system.js